// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__qB63Z","content":"styles_content__1HRF_"};